import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import type { AIAgent } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type AgentDeleteModalProps = ModalProps & {
    title?: string;
    data?: AIAgent;
};

export const AgentDeleteModal = ({
    title = 'Delete AI Agent',
    data,
    ...props
}: AgentDeleteModalProps) => {
    const { deleteAgent } = useAgentActions();

    return (
        <StyledModal
            title={title}
            okText="Delete"
            {...props}
            confirmLoading={deleteAgent?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteAgent.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this AI Agent?</p>
        </StyledModal>
    );
};

export default AgentDeleteModal;
